<!--
   税筹输入企业信息界面
   lyj
 -->
<template>
  <div class="invoice-o-w">
    <el-dialog
      class="invoice"
      ref="taxDecisionDialog"
      width="36%"
      :close-on-click-modal="false"
      :visible.sync="showDialog"
      :before-close="handleClose"
      :destroy-on-close="true"
    >
    <!-- title -->
    <div class="invo-header" slot="title">
      税筹策划
    </div>
    <!-- type-change -->
    <div class="invo-type-w">
      <span class="inv-type-btn" @click="typeChg(1)" :class="{'active':vAddForm.invoiceType===1}">税筹专家</span>
    </div>
    <!-- info -->
    <el-alert :closable="false"
      title="请填写您单位的基本信息，便于我们制定最适合您的节税方案（方案免费）。"
      type="warning">
    </el-alert>

    <!-- 电子发票 -->
    <div class="invo-e-form-w" v-if="vAddForm.invoiceType === 1">
      <el-form ref="eInvForm" :model="vAddForm" label-position="right"  label-width="140px">
        <el-form-item label="姓名：" prop="enterpriseAddress" :rules="nameRule">
          <el-input placeholder="请输入姓名" v-model="vAddForm.enterpriseName"></el-input>
        </el-form-item>
        <el-form-item label="联系电话：" prop="enterpriseMobile" :rules="mobileRule">
          <el-input placeholder="请输入联系电话" v-model="vAddForm.enterpriseMobile"></el-input>
        </el-form-item>
        <el-form-item label="您公司的主营业务（可多选）："  >
          <el-checkbox-group v-model="vAddForm.mainBusiness">
            <el-checkbox label="生产型企业" name="type"></el-checkbox>
            <el-checkbox label="建筑型企业" name="type"></el-checkbox>
            <el-checkbox label="贸易型公司" name="type"></el-checkbox>
            <el-checkbox label="现代服务类公司" name="type"></el-checkbox>
            <el-checkbox label="工程企业" name="type"></el-checkbox>
            <el-checkbox label="其他" name="type"></el-checkbox>
          </el-checkbox-group>
        </el-form-item>

        <el-form-item label="税筹需求（可多选）：" prop="enterpriseMobile" >
          <el-checkbox-group v-model="vAddForm.taxDecisionReq">
            <el-checkbox label="缺成本发票" name="type"></el-checkbox>
            <el-checkbox label="利润提现" name="type"></el-checkbox>
            <el-checkbox label="股东分红" name="type"></el-checkbox>
            <el-checkbox label="居间佣金" name="type"></el-checkbox>
            <el-checkbox label="资金发放" name="type"></el-checkbox>
            <el-checkbox label="增值税筹划" name="type"></el-checkbox>
            <el-checkbox label="持股平台" name="type"></el-checkbox>
            <el-checkbox label="股权转让" name="type"></el-checkbox>
          </el-checkbox-group>
        </el-form-item>


      </el-form>
    </div>

    <!-- btns -->
    <div slot="footer" class="invo-footer">
      <el-button @click="submit" type="primary">立即获取节税方案</el-button>
    </div>

    </el-dialog>
  </div>
</template>

<script>
import API from '@/api/ord-api'
import rule from '@/util/rule'
import { mapGetters } from 'vuex'
export default {
  props: {
    show: {
      type: Boolean,
      default: false
    },
  },
  data () {
    return {
      rule,
      showDialog: this.show,
      prdId:0,
      vAddForm: {
        goodsId: this.prdId,
        enterpriseName:'',//姓名或企业名称
        enterpriseMobile: '', //电话
        mainBusiness:[],
        taxDecisionReq:[]
      },
      nameRule: {
        required: true,
        validator: (rule, value, cb) => {
          const reg = /^.{1,100}$/
          if (!value) {
            return cb(new Error('名称不能为空'))
          } else if (!reg.test(value)) {
            return cb(new Error('请输入1-100位字符'))
          } else {
            cb()
          }
        }
      },
     mobileRule: {
        required: true,
        validator: (rule, value, cb) => {
          const reg = /(^(\d{3,4}-)?\d{7,8})$|(1[0-9][0-9]{9})/
          if (!value) {
            return cb(new Error('企业电话不能为空'))
          } else if (!reg.test(value)) {
            return cb(new Error('请输入电话号码'))
          } else {
            cb()
          }
        }
      }
    }
  },
  computed: {
    ...mapGetters(['memberInfo'])
  },
  created () {
    this.prdId = this.$route.params.prodId
    //const re = await API.getPrdDetail(this.prdId)
    //this.product = re.data.result
  },
  mounted () {

  },
  activated () {

  },
  deactivated () {

  },
  watch: {
    show (v) {
      this.showDialog = v
    }
  },
  methods: {
    handleClose (done) {
      this.$emit('visibleUpdate', false)
      done()
    },
    async submit () {
      this.$refs.eInvForm.validate(async valid => {
        console.log(valid)
        if (valid) {
          if (this.orderId !== '') {
            this.vAddForm.id = this.orderId
            this.vAddForm.invoiceRiseType = -1
            const res = await API.supplementInvoice(this.vAddForm)
            if (res.data.statusCode === '200') {
              this.$message({
                type: 'success',
                message: res.data.message
              })
            } else {
              this.$message({
                type: 'error',
                message: res.data.message
              })
            }
            this.$emit('visibleUpdate', false)
          } else {
            this.vAddForm.invoiceRiseType = -1
            // if (this.validateForm()) {
            //   this.$emit('invoiceVal', this.getFormData(this.vAddForm.invoiceType, this.vAddForm.invoiceRiseType))
            // } else {
            //   this.$alert('发票项目填写有误，请检查！', '提示', {
            //     confirmButtonText: '确定',
            //     callback: action => {
            //       console.log('')
            //     }
            //   })
            //   return
            // }
            // 将所有参数通过事件传递到外部
            this.$emit('savedInvoceInfo', this.vAddForm)
          }
        }
      })
    },

    typeChg (v) {
      // 去掉红色未通过验证提示
      if (v === 1) {
        this.$refs.eInvForm.clearValidate()
        this.vAddForm.invoiceRiseType = 0
      } else {
        this.$refs.eInvForm.clearValidate()
      }
    },


    getFormData (t, r) {
      const form = this.vAddForm
      arr = arr.concat(['enterpriseName', 'enterpriseMobile'])
      this._.mapKeys(form, (value, key) => {
        if (!this._.includes(arr, key)) {
          form[key] = ''
        }
      })
      return form
    },
    validateForm () {
      const form = this.vAddForm
      let re = true
      let arr = []
     if (t === 1 && r === 0) { //个人
       arr = arr.concat(['enterpriseName', 'mailbox'])
     } else
      if (t === 1 && (r === 1 )) { //企业
        arr = arr.concat(['enterpriseName', 'taxpayerNumber', 'mailbox'])
      } else if (t === 1 && r === 2) { //事业
        arr = arr.concat(['enterpriseName', 'taxpayerNumber', 'mailbox'])
      } else if (t === 2) { //专票
        arr = arr.concat(['enterpriseName', 'taxpayerNumber', 'bank', 'bankNumber', 'enterpriseAddress', 'enterpriseMobile'])
      }
      this._.forIn(form, (value, key) => {
        if (this._.includes(arr, key) && re) {
          if (form[key] === '') {
            re = false
          }
        }
      })
      return re
    }
  },
  components: {

  }
}
</script>

<style lang="stylus">
.invoice-o-w
  .invoice
    .invo-type-w
      height 46px
      .inv-type-btn
        display inline-block
        padding 8px 16px
        margin 0 10px
        border 1px solid theme-color
        color theme-color
        background-color theme-color-light
        &.active
          color theme-color-light
          background-color theme-color
    .invo-e-form-w
      margin-top 10px
      .el-form-item
        margin-bottom 20px
    .invo-v-form-w
      margin-top 10px
</style>
